<template>
  <v-select
    :value="value"
    :items="items"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'AgCompanySelect',
  props: {
    value: {
      type: [Array, String],
      default: null,
    },
    companyList: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    items () {
      return this.companyList.map(company => ({
        value: company.id,
        text: company.displayName,
      }))
    },
  },
}
</script>
